import ProductCard from "../ProductCard";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

//custom hooks
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFavorites } from "../../hooks/useFavorites";
import getAuthHeaders from "../../utils/getAuthHeaders";

const Favorites = () => {
  const { user: userAuth } = useAuthContext();
  const { favorites } = useFavorites();
  const [hydratedFavorites, setHydratedFavorites] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);

  // Hydrate favorites with full product details
  useEffect(() => {
    const fetchFullProductDetails = async () => {
      if (!favorites || favorites.length === 0) {
        setHydratedFavorites([]);
        setIsLoadingProducts(false);
        return;
      }

      if (!userAuth) {
        setIsLoadingProducts(false);
        return;
      }

      try {
        setIsLoadingProducts(true);
        const authHeader = await getAuthHeaders(userAuth);

        const fetchUrl =
          process.env.NODE_ENV === "development"
            ? `${process.env.REACT_APP_NETWORK}/api/products/by-ids`
            : "/api/products/by-ids";

        const response = await fetch(fetchUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...authHeader,
          },
          body: JSON.stringify({
            productIds: favorites,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch products: ${response.statusText}`);
        }

        const data = await response.json();
        setHydratedFavorites(data.products || []);
        setIsLoadingProducts(false);
      } catch (error) {
        console.error("Error fetching product details:", error);
        setIsLoadingProducts(false);
      }
    };

    fetchFullProductDetails();
  }, [favorites, userAuth]);

  return (
    <div>
      <h1>My Favorites</h1>

      {favorites.length === 0 && !isLoadingProducts && (
        <div
          style={{
            padding: "50px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontFamily: "sans-serif",
            textAlign: "center",
          }}
        >
          <h3>No favorites yet!</h3>
          <p>
            Click the heart icon on any product to add it to your favorites.
          </p>
          <Link to="/products" style={{ color: "#359356", fontWeight: "bold" }}>
            Browse Products →
          </Link>
        </div>
      )}

      {isLoadingProducts && favorites.length > 0 && (
        <h3>Loading products...</h3>
      )}

      <div className="product-grid">
        {!isLoadingProducts &&
          hydratedFavorites.length > 0 &&
          hydratedFavorites.map((item) => {
            return <ProductCard key={item._id} item={item}></ProductCard>;
          })}
      </div>
    </div>
  );
};

export default Favorites;
